import React from 'react';
import { CheckCircle, Factory, Users, Leaf, TrendingUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SectionHeader } from './shared/SectionHeader';

const QC_IMAGE = "https://images.unsplash.com/photo-1774887810190-5de1cc9cb06e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxxdWFsaXR5JTIwY29udHJvbCUyMGZhY3RvcnklMjBpbnNwZWN0aW9ufGVufDB8fHx8MTc3NzY4NjMwOHww&ixlib=rb-4.1.0&q=85";

const capacityIcons = [Factory, Leaf, TrendingUp, Users];

export default function OperationalExcellence() {
  const { t } = useLanguage();
  const qcItems = t('operations.qcItems');
  const capacityItems = t('operations.capacityItems');

  return (
    <section id="operations" className="py-24 md:py-32 bg-white" data-testid="operations-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader label={t('operations.sectionLabel')} title={t('operations.title')} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img
              src={QC_IMAGE}
              alt="Quality Control Process"
              loading="lazy"
              className="w-full h-[500px] object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-brand-green p-6 hidden md:block">
              <p className="text-brand-orange text-xs uppercase tracking-widest font-semibold">Batch Traceability</p>
              <p className="text-white text-2xl font-black mt-1">100%</p>
              <p className="text-white/60 text-xs mt-1">Farm to Container</p>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-2xl font-bold text-slate-900 mb-8">
              {t('operations.qcTitle')}
            </h3>
            <div className="space-y-5">
              {Array.isArray(qcItems) && qcItems.map((item) => (
                <div key={item} className="flex gap-4 items-start" data-testid={`qc-item-${item}`}>
                  <CheckCircle className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" />
                  <p className="text-slate-600 leading-relaxed">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-24">
          <h3 className="font-heading text-2xl font-bold text-slate-900 text-center mb-12">
            {t('operations.capacityTitle')}
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {Array.isArray(capacityItems) && capacityItems.map((item, i) => {
              const Icon = capacityIcons[i];
              return (
                <div
                  key={item.label}
                  className="bg-slate-50 border border-slate-100 p-8 text-center group hover:bg-brand-green transition-colors duration-300"
                  data-testid={`capacity-card-${i}`}
                >
                  <Icon className="w-8 h-8 text-brand-orange mx-auto mb-4 group-hover:text-white transition-colors" />
                  <p className="text-2xl md:text-3xl font-black text-slate-900 group-hover:text-white transition-colors">
                    {item.value}
                  </p>
                  <p className="text-xs text-slate-500 uppercase tracking-wider mt-2 font-semibold group-hover:text-white/60 transition-colors">
                    {item.label}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
